<template>
    <div class="vipBox" :class="{'vipBoxDark':isDark}">
        <div class="vipBtn" @click="goBuyVip">
            <p>开通会员</p>
            <p class="locked">开通会员可免费查看更多数据模型</p>
            <span class="save">{{saveMoney}}</span>
        </div>
        <div class="placeholder" :style="{'width': '100%','height': bottomHeight + 'px'}"></div>
    </div>
</template>

<script>
import { isJHApp, getAppBottomHeight, isLogin, doLogin } from "../../../utils/base"
// import jsbridg from '../../../utils/jsbridg'
export default {
    name: "vipEnter",
    props: ['saveMoney', 'isDark'],
    data () {
        return {
            bottomHeight: 0
        }
    },
    created () {
        this.bottomHeight = getAppBottomHeight();
    },
    methods: {
        // 跳转开通会员页面
        goBuyVip () {
            if (!isLogin()) {
                doLogin();
                return;
            }
            let vipUrl = "";
            if (process.env.NODE_ENV === "production") {
                vipUrl = process.env.VUE_APP_DOMAIN + '/vip?top_bar_style=2';
            } else {
                vipUrl = process.env.VUE_APP_DOMAIN + '/vip?top_bar_style=2';
            }
            if (isJHApp()) {
                window.location.href = vipUrl
                // jsbridg.goWebview({
                //     url: vipUrl,
                //     jumptype: 2
                // });
            } else {
                window.open(vipUrl);
            }
        }
    }
}
</script>

<style lang="less" scoped>
.vipBox{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: auto;
    padding: 5px 14px;
    background:#FFFFFF;
    &.none{
        display: none;
    }
    .vipBtn{
        position: relative;
        width: 100%;
        height: 44px;
        padding-top: 3px;
        text-align: center;
        background: #169aff;
        border-radius: 5px;
        font-size: 15px;
        color: #FFFFFF;
        .locked{
            font-size: 10px;
        }
        .save{
            position: absolute;
            left: 50%;
            top: -15px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 6px;
            height: 15px;
            font-size: 10px;
            color: #FFFFFF;
            background: #FF5048;
            border-radius: 7px;
            z-index: 20;
            &::before{
                position: absolute;
                left: 30%;
                bottom: -11px;
                content: '';
                width: 0;
                height: 0;
                border: 6px solid transparent;
                border-top-color: #FF5048;
            }
        }
    }
    .placeholder{
        width: 100%;
        height: 29px;
    }
}
.vipBoxDark{
    background-color: #2f2f2f;
}
</style>
